export function Logo({ className = "h-7 w-auto", showText = true }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg
        viewBox="0 0 44 44"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Tip Top Property logo"
        className="h-7 w-7"
      >
        <defs>
          <linearGradient id="ttp-roof" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="hsl(var(--primary))" />
            <stop offset="100%" stopColor="hsl(var(--primary))" />
          </linearGradient>
        </defs>
        {/* Outer square frame */}
        <rect x="2" y="2" width="40" height="40" rx="6" fill="none" stroke="hsl(var(--primary))" strokeWidth="2" />
        {/* House silhouette */}
        <path
          d="M11 24 L22 13 L33 24 V33 H11 Z"
          fill="url(#ttp-roof)"
        />
        {/* Door */}
        <rect x="19.5" y="26" width="5" height="7" fill="hsl(var(--background))" />
        {/* Accent diamond on roof — copper */}
        <path d="M22 9 L25.5 12.5 L22 16 L18.5 12.5 Z" fill="hsl(var(--accent))" />
      </svg>
      {showText && (
        <div className="flex flex-col leading-none">
          <span className="font-display text-[15px] font-bold tracking-tight text-foreground">Tip Top</span>
          <span className="text-[10px] uppercase tracking-[0.22em] text-accent font-bold">Property</span>
        </div>
      )}
    </div>
  );
}

export default Logo;
